var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { omitStyleProps } from '../../utils/props';
import { applySpacings } from '../../utils/tailwind';
import { Icon } from '../Icon/Icon';
import { IconButton } from '../IconButton/IconButton';
import { SuperEllipse } from '../SuperEllipse/SuperEllipse';
import { useColorSet } from '../ThemeProvider/useColorSet';
import { Typography } from '../Typography/Typography';
import { actionsContainer, alert, iconWrapper } from './styles';
const severityMapping = {
    error: 'critical',
    warning: 'warning',
    success: 'success',
    info: 'info',
};
const ICON_SIZE = 20;
export const Alert = (_a) => {
    var { title, titleComponent = 'p', secondaryText, secondaryTextComponent = 'p', icon, withSuperEllipse, actions, severity = 'error', onClose, actionLabels, children } = _a, props = __rest(_a, ["title", "titleComponent", "secondaryText", "secondaryTextComponent", "icon", "withSuperEllipse", "actions", "severity", "onClose", "actionLabels", "children"]);
    const colors = useColorSet({
        colorSet: severityMapping[severity],
    });
    return (_jsxs("div", Object.assign({}, omitStyleProps(props), { className: alert({
            severity,
            className: [applySpacings(props), props.className],
        }), children: [icon && !withSuperEllipse && (_jsx("div", { className: iconWrapper(), children: _jsx(Icon, { name: icon, color: colors.content, size: ICON_SIZE }) })), icon && withSuperEllipse && (_jsx(SuperEllipse, { size: 56, icon: icon, colorSet: severityMapping[severity], defaultBackground: true })), _jsxs("div", { className: "w-full", children: [children || (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body", weight: "medium", component: titleComponent, color: colors.content, children: title }), secondaryText && (_jsx(Typography, { variant: "callout", component: secondaryTextComponent, color: colors.content, children: secondaryText }))] })), actions && _jsxs("div", { className: actionsContainer({ severity }), children: [" ", actions] })] }), onClose ? (_jsx("div", { className: iconWrapper(), children: _jsx(IconButton, { "aria-label": actionLabels === null || actionLabels === void 0 ? void 0 : actionLabels.close, size: 24, variant: "text", name: "cancel", onClick: onClose }) })) : null] })));
};
